import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

const authority = import.meta.env.VITE_ZITADEL_AUTHORITY as string;
const client_id = import.meta.env.VITE_ZITADEL_CLIENT_ID as string;

/** OIDC redirect URI — must match Zitadel app config exactly (localhost ≠ 127.0.0.1). */
export function getOidcRedirectUri(origin = window.location.origin): string {
    return import.meta.env.VITE_ZITADEL_REDIRECT_URI || `${origin}/authz`;
}

/** Post-logout redirect — must be allowlisted separately in Zitadel. */
export function getOidcPostLogoutRedirectUri(origin = window.location.origin): string {
    return import.meta.env.VITE_ZITADEL_POST_LOGOUT_REDIRECT_URI || `${origin}/`;
}

const AUTH_PAGES = new Set(['/auth', '/authz']);
let authRedirectStarted = false;

/**
 * Send the browser to the sign-in page and come back to `returnTo` after Zitadel.
 * Relative paths only. Parallel 401s share one navigation.
 */
export function redirectToAuth(returnTo?: string) {
    if (authRedirectStarted) return;
    const path = window.location.pathname;
    if (AUTH_PAGES.has(path)) return;

    const target = returnTo ?? `${path}${window.location.search}${window.location.hash}`;
    if (!target.startsWith('/') || target.startsWith('//') || target.startsWith('/\\')) return;

    authRedirectStarted = true;
    const q = new URLSearchParams({ redirectTo: target });
    window.location.assign(`/authz?${q.toString()}`);
}

export const userManager = new UserManager({
    authority,
    client_id,
    redirect_uri: getOidcRedirectUri(),
    post_logout_redirect_uri: getOidcPostLogoutRedirectUri(),
    response_type: 'code',
    scope: 'openid profile email',
    loadUserInfo: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
});
